(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WAPI", [], factory);
	else if(typeof exports === 'object')
		exports["WAPI"] = factory();
	else
		root["WAPI"] = factory();
})(self, () => {
return 